import Grid from "@material-ui/core/Grid";
import { instance } from "Actions/AxiosInstance";
import { GetMasterData } from "Actions/MasterCodeAction";
import DynamicForm from "Component/DynamicForm";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import CallOutNew from "Component/Headers/callOutNew";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { ErrorMessages } from "Constants";
import pointingHandIcon from "Assets/Svg/hand-pointing-right.svg";
import calenderIcon from "Assets/newicons/user-interface/calendar/outline/calendar-outline-16px.svg";
import userIcon from "Assets/newicons/user/user/outline/user-outline-16px.svg";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import { isSpaceInString } from "Utils";

class reviewperiod extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      selectedData: props.selectedData || null,
      audienceType: [],
      commonOption: [],
      reviewStructure: [],
      selectedSection: props.selectedData.length == 1 ? 1 : 2,
      WeightageType: [],
    };

    this.isBackButtonClicked = false;

    this.onSubmit = this.onSubmit.bind(this);
    this.onSaveDraft = this.onSaveDraft.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onBeforeUpload = this.onBeforeUpload.bind(this);
    this.handleSectionChange = this.handleSectionChange.bind(this);
    this.handleSectiondata = this.handleSectiondata.bind(this);
  }

  async componentDidMount() {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.onSubmit,
      // onSaveDraft:
      //   this.props.selectedData && this.props.selectedData.isdraft
      //     ? this.onSaveDraft
      //     : null,
      onSaveDraft: this.onSaveDraft,
    });
    const audienceType = await GetMasterData("AudienceForType");
    const { selectedData } = this.props;
    // this.handleChange1(selectedData.length == 1 ? 1 : 2);
    this.getStructure();
    if (selectedData.formfor && selectedData.formfor.fortypeid != null) {
      selectedData.formfor.fortypeid == 2 && this.GetBusinessUnits();
      selectedData.formfor.fortypeid == 3 && this.GetDepartmentList();
      selectedData.formfor.fortypeid == 4 && this.GetOfficeLocationList();
      selectedData.formfor.fortypeid == 5 && this.GetDesignationList();
      selectedData.formfor.fortypeid == 6 && this.getAllEmp();
      selectedData.formfor.fortypeid == 7 && this.GetTeam();
    }

    const WeightageType = await GetMasterData("WeightageType");

    // selectedData.section[0].sectionname = selectedData.section[0].sectionname
    //   ? selectedData.section[0].sectionname
    //   : "Result";

    // selectedData.section[1].sectionname = selectedData.section[1].sectionname
    //   ? selectedData.section[1].sectionname
    //   : "Behaviour";
    const isdata = selectedData.length == 1 ? false : true;
    console.log("isdata: ", isdata);
    this.setState(
      {
        audienceType: audienceType ? audienceType.data.result : [],
        WeightageType: WeightageType ? WeightageType.data.result : [],
        selectedData,
        selectedSection: selectedData.length == 1 ? 1 : 2,
      },
      () => this.handleSectiondata(isdata),
    );
  }

  handleSectiondata(isdata) {
    const { selectedData } = this.state;
    this.props.onSkipClick1(this.state.selectedData, isdata);
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.preventDefault();
    if (!this.isBackButtonClicked) {
      if (window.confirm("Are you sure you want to close the window/tab?")) {
        this.isBackButtonClicked = true;
        this.props.history.push("./config/perform/360/form");
      } else {
        window.history.pushState(null, null, window.location.pathname);
        this.isBackButtonClicked = false;
      }
    }
  }

  getStructure() {
    // const data = { "isactive": true, "isdraft": true, "limit": 500, "offset": 0 };
    // instance.post("perform/reviewstructure", data)
    //   .then((result) => {
    //   this.setState({
    //     reviewStructure: result.data.result.map((obj) => ({
    //       displayvalue: obj.reviewstructureid,
    //       displayname: obj.structurename,
    //     })),
    //   });
    // })
    // .catch((error) => {
    //   this.props.enqueueSnackbar(
    //     error.response ? error.response.data.error.message : error.message,
    //     { variant: "error" },
    //   );
    // });
    const data = {
      isactive: true,
    };
    instance
      .post("perform/reviewstructurelist", data)
      .then((result) => {
        this.setState({ reviewStructure: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getAllEmp() {
    const { login } = this.props.AuthenticationAction;
    const data = {
      featurekey: "reviewform",
      subscriptionid: login.subscriptionid,
    };
    instance
      .post(`subscription/getemployeelist`, data)
      .then((result) => {
        const { selectedData } = this.state;
        const x =
          selectedData &&
          selectedData.formfor &&
          selectedData.formfor.fortypeid == 6
            ? true
            : false;
        this.setState({
          commonOption: x ? result.data.result : this.state.commonOption,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetOfficeLocationList() {
    const { login } = this.props.AuthenticationAction;
    const data = {
      featurekey: "reviewform",
      subscriptionid: login.subscriptionid,
    };
    instance
      .post(`subscription/allcompanylocation`, data)
      .then((result) => {
        this.setState({ commonOption: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetBusinessUnits() {
    const data = {
      featurekey: "reviewform",
    };
    instance
      .post("subscription/allbusinessunit", data)
      .then((result) => {
        this.setState({ commonOption: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetDepartmentList() {
    const data = {
      featurekey: "reviewform",
    };
    instance
      .post(`subscription/alldepartment`, data)
      .then((result) => {
        this.setState({ commonOption: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetDesignationList() {
    instance
      .get(`subscription/alldesignation`)
      .then((result) => {
        this.setState({ commonOption: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetTeam() {
    instance
      .get("subscription/allteam")
      .then((result) => {
        this.setState({ commonOption: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  handleChange(value, key) {
    const { selectedData, selectedSection } = this.state;
    if (key == "fortypeid") {
      selectedData.formfor.forids = null;
      selectedData.formfor.fortypeid = value;
      this.setState(
        {
          selectedData,
        },
        () => {
          value == 2 && this.GetBusinessUnits();
          value == 3 && this.GetDepartmentList();
          value == 4 && this.GetOfficeLocationList();
          value == 5 && this.GetDesignationList();
          value == 6 && this.getAllEmp();
          value == 7 && this.GetTeam();
        },
      );
    } else if (key == "forids") {
      selectedData.formfor.forids = value;
    } else if (key == "reviewstructureid") {
      selectedData[key] = value;
      selectedData.formfor = {
        reviewformforid: null,
        fortypeid: null,
        forids: null,
      };
      selectedData.section = selectedData.section.map((section) => {
        const obj = {
          ...section,
          focusarea: section.focusarea.map((focus) => ({
            ...focus,
            reviewquestion:
              focus.reviewquestion && focus.reviewquestion.length > 0
                ? focus.reviewquestion.map((q) => ({
                    ...q,
                    questionevaluation: [],
                  }))
                : [],
          })),
        };
        return obj;
      });
    } else {
      selectedData[key] = value;
    }
    this.setState({
      selectedData,
      selectedSection,
    });
  }

  handleChange1 = (selectedSection) => {
    const { selectedData } = this.state;
    if (selectedSection == 1) {
      selectedData.section[1] = {
        reviewsectionid: null,
        sectionname: "Section B",
        weightagetypeid: null,
        focusarea: [],
      };
      selectedData.length = 1;
      // this.props.AllStep.splice(2, 1);
      this.setState(
        {
          selectedSection,
          selectedData,
        },
        () => this.props.onSkipClick1(selectedData, false),
      );
    } else {
      const obj = {
        focusareaid: null,
        focusareaname: "Focus area 1",
        competencyid: null,
        reviewquestion: [],
      };
      const area = [];
      area.push(obj);
      selectedData.section = [
        {
          reviewsectionid: null,
          sectionname: "Result",
          weightagetypeid: null,
          focusarea: area,
        },
        {
          reviewsectionid: null,
          sectionname: "Behaviour",
          weightagetypeid: null,
          focusarea: area,
        },
      ];
      selectedData.length = 2;

      this.setState(
        {
          selectedSection,
          selectedData,
        },
        () => this.props.onSkipClick1(selectedData, true),
      );
    }
  };

  setsection = (key, value) => {
    const { selectedData } = this.state;
    const { sectionname } = this.state.selectedData.section[0].sectionname;
    // if (key == "sectionname") {
    //   selectedData.section[0].sectionname = value;
    // }

    this.setState({
      [key]: value,
    });
  };

  handleBlur(value, key) {
    const { selectedData } = this.state;
    if (value) {
      instance
        .post("perform/checkuniquereviewformname", {
          formtitle: value,
          reviewformid: selectedData && selectedData.reviewformid,
        })
        .then((result) => {
          selectedData[key] = value;
          this.setState({ selectedData });
        })
        .catch((error) => {
          selectedData[key] = "";
          this.setState({ selectedData });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  onSaveDraft() {
    const { selectedData } = this.state;
    console.log("selectedData: ", selectedData);
    const { reviewstructureid } = this.state.selectedData;
    selectedData.isdraft = true;
    const { reviewStructure } = this.state;
    const obj =
      reviewStructure &&
      reviewStructure.find((x) => x.displayvalue == reviewstructureid);
    const obj1 =
      selectedData &&
      selectedData.section &&
      selectedData.section.filter((x1) => x1.focusarea.length > 0);
    if (!selectedData.formtitle) {
      this.props.enqueueSnackbar("Please select review name", {
        variant: "error",
      });
    } else if (!selectedData.reviewstructureid) {
      this.props.enqueueSnackbar("Please select review structure", {
        variant: "error",
      });
    } else if (
      selectedData.formfor &&
      selectedData.formfor.fortypeid &&
      (selectedData.formfor.fortypeid == 1
        ? false
        : !selectedData.formfor.forids)
    ) {
      this.props.enqueueSnackbar("Please select group data", {
        variant: "error",
      });
    } else if (obj1.findIndex((y) => !y.weightagetypeid) != -1) {
      this.props.enqueueSnackbar("please add weightage for each sections", {
        variant: "error",
      });
    } else {
      if (
        selectedData.formfor &&
        !selectedData.formfor.fortypeid &&
        !selectedData.formfor.forids
      ) {
        selectedData.formfor = null;
      } else if (obj && selectedData.formfor && selectedData.formfor.forids) {
        selectedData.formfor.forids = Array.isArray(selectedData.formfor.forids)
          ? selectedData.formfor.forids.join(",")
          : selectedData.formfor.forids;
      }
      const index = selectedData.section.findIndex(
        (x) => x.weightagetypeid == null,
      );
      console.log("index: ", index);
      if (index != -1) {
        selectedData.section.splice(index, 1);
      }
      console.log("selectedData: ", selectedData);
      instance
        .post("perform/configreviewform", selectedData)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.onCancel(true);
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  onSubmit() {
    const { selectedData } = this.state;
    // console.log('selectedData: ', selectedData);
    const { reviewstructureid } = this.state.selectedData;
    const { reviewStructure } = this.state;
    const obj =
      reviewStructure &&
      reviewStructure.find((x) => x.displayvalue == reviewstructureid);
    const obj1 =
      selectedData &&
      selectedData.section &&
      selectedData.section.filter((x1) => x1.focusarea.length > 0);
    // console.log('obj1: ', obj1);
    // const isvalid = obj1.findIndex(y => !y.weightagetypeid);
    // console.log('isvalid: ', isvalid);
    if (!selectedData.formtitle) {
      this.props.enqueueSnackbar("Please select review name", {
        variant: "error",
      });
    } else if (selectedData.formtitle && !isSpaceInString(selectedData.formtitle)) {
      this.state.selectedData.formtitle = this.state.selectedData.formtitle.trim();
      
    }
 else if (!selectedData.reviewstructureid) {
      this.props.enqueueSnackbar("Please select review structure", {
        variant: "error",
      });
    } else if (
      obj &&
      obj.reviewtypeid == 1 &&
      selectedData.formfor &&
      !selectedData.formfor.fortypeid
    ) {
      this.props.enqueueSnackbar("Please select group type", {
        variant: "error",
      });
    } else if (
      obj &&
      obj.reviewtypeid == 1 &&
      selectedData.formfor &&
      (selectedData.formfor.fortypeid == 1
        ? false
        : !selectedData.formfor.forids)
    ) {
      this.props.enqueueSnackbar("Please select group data", {
        variant: "error",
      });
    } else if (obj1.findIndex((y) => !y.weightagetypeid) != -1) {
      this.props.enqueueSnackbar("please add weightage for each sections", {
        variant: "error",
      });
    } else {
      this.props.onNextClick(selectedData);
    }
  }

  handleSectionChange(value, key, index) {
    const { selectedSection, selectedData } = this.state;
    // if(key =="sectionname"){

    // }
    if (selectedData && index != null) {
      // selectedSection[key] = value;

      selectedData.section[index][key] = value;
      this.setState({
        selectedData,
        selectedSection,
      });
    }
  }

  render() {
    const {
      formtitle,
      reviewstructureid,
      formfor,
      reviewformid,
      isdraft,
      section,
    } = this.state.selectedData;
    console.log("section: ", section);
    let fortypeid = null;
    let forids = null;
    if (formfor) {
      fortypeid = formfor.fortypeid;
      forids = formfor.forids;
    }
    const { reviewStructure, WeightageType } = this.state;
    const obj =
      reviewStructure &&
      reviewStructure.find((x) => x.displayvalue == reviewstructureid);
    console.log("obj: ", obj);
    return (
      <div className="padding-top-0">
        <div className="width60">
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              <p className="normal-dark margin-bottom-8 display-flex">
                <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
                Review form name
              </p>

              <div className="width60 margin-bottom-16">
                <DynamicForm
                  fields={textinputconverter({
                    value: formtitle,
                    placeholder: "Enter form name",
                    label: "",
                  })}
                  onChange={(value) => {
                    this.handleChange(value, "formtitle");
                  }}
                  onBlur={(value) => {
                    this.handleBlur(value.target.value, "formtitle");
                  }}
                />
              </div>

              <p className="normal-dark margin-bottom-8 display-flex">
                <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
                Assign to a review structure
              </p>

              <div className="width60">
                <DynamicForm
                  fields={selectinputconverter({
                    value: reviewstructureid,
                    placeholder: "Select review structure",
                    label: "",
                    disabled: reviewformid && !isdraft ? true : false,
                    options: this.state.reviewStructure,
                  })}
                  onChange={(id) => {
                    this.handleChange(id, "reviewstructureid");
                  }}
                />
              </div>

              <div
                className="helping-hand-wrapper"
                style={{ padding: 16, width: 324, marginBottom: 32 }}
              >
                <p className="helping-hand-text text-center margin-bottom-16">
                  Helping Hand 👋 - Details
                </p>
                <div className="display-flex">
                  <img src={calenderIcon}></img>
                  <p className="extra-small-dark-secondary margin-left-16">
                    Monthly
                  </p>
                </div>
                <div
                  className="display-flex"
                  style={{ alignItems: "flex-start" }}
                >
                  <img src={userIcon}></img>
                  <div className="margin-left-16">
                    <p className="extra-small-dark-secondary">Self</p>
                    <p className="extra-small-dark-secondary">
                      Manager (Primary, Additional, Manager’s Manager)
                    </p>
                    <p className="extra-small-dark-secondary">Co-workers</p>
                    <p className="extra-small-dark-secondary">Direct reports</p>
                  </div>
                </div>
              </div>

              {reviewstructureid &&
                reviewStructure &&
                obj &&
                obj.reviewtypeid == 1 && (
                  <div className="margin-bottom-16">
                    <p className="normal-dark margin-bottom-8 display-flex">
                      <img
                        className="margin-right-16"
                        src={pointingHandIcon}
                      ></img>{" "}
                      Select employees under review for this form
                    </p>
                    <p className="small-dark-secondary margin-bottom-16">
                      Review will be automatically opened for current and future
                      employees
                    </p>
                    <div style={{ width: 250 }}>
                      <DynamicForm
                        fields={selectinputconverter({
                          value: fortypeid,
                          options: this.state.audienceType,
                          placeholder: "Select type",
                          label: "Selection type",
                        })}
                        onChange={(id) => {
                          this.handleChange(id, "fortypeid");
                        }}
                      />
                    </div>

                    {fortypeid && fortypeid != 1 && (
                      <div style={{ width: 250 }}>
                        <DynamicForm
                          fields={multiselectinputconverter({
                            idonly: true,
                            value: Array.isArray(forids)
                              ? forids
                              : forids
                              ? forids.split(",")
                              : [],
                            options: this.state.commonOption,
                            placeholder:
                              fortypeid == 2
                                ? "Select Busines unit"
                                : fortypeid == 3
                                ? "Select Department"
                                : fortypeid == 4
                                ? "Select Location"
                                : fortypeid == 5
                                ? "Select Designation"
                                : fortypeid == 6
                                ? "Select employee"
                                : "Select team",
                            label:
                              fortypeid == 2
                                ? "Busines unit"
                                : fortypeid == 3
                                ? "Department"
                                : fortypeid == 4
                                ? "Location"
                                : fortypeid == 5
                                ? "Designation"
                                : fortypeid == 6
                                ? "Select employee"
                                : "Select team",
                          })}
                          onChange={(ids) => this.handleChange(ids, "forids")}
                        />
                      </div>
                    )}
                  </div>
                )}

              <div>
                <p className="normal-dark margin-bottom-8 display-flex">
                  <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
                  Do you want to include this form's rating outcome in your annual combined ratings?
                </p>

                <span style={{ width: 148 }}>
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: this.state.selectedData.isincluderating,
                      label: "Yes",
                      labelclass: "small-dark-secondary t-bold margin-top-4 ",
                      // disabled: this.state.check && this.state.check.editable ? false : true,
                    })}
                    onChange={() => this.handleChange(true, "isincluderating") }
                  />
                </span>
                <span style={{ width: 172 }}>
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: !this.state.selectedData.isincluderating,
                      label: "No",
                      labelclass: "small-dark-secondary t-bold margin-top-4",
                    })}
                    onChange={() => this.handleChange(false, "isincluderating")}
                  />
                </span>
              </div>

              <p className="normal-dark margin-bottom-8 display-flex">
                <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
                Would you like to split the form into 2 sections?
              </p>
              <p className="small-dark-secondary margin-bottom-16">
                Sections help organize the form into themes or categories
              </p>

              <div className="margin-top-8">
                <span style={{ width: 148 }}>
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: this.state.selectedSection == 1,
                      label: "One section",
                      labelclass: "small-dark-secondary t-bold margin-top-4 ",
                      // disabled: this.state.check && this.state.check.editable ? false : true,
                    })}
                    onChange={() => {
                      this.handleChange1("1");
                    }}
                  />
                </span>
                <span style={{ width: 172 }}>
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: this.state.selectedSection == 2,
                      label: "Two sections",
                      labelclass: "small-dark-secondary t-bold margin-top-4",
                    })}
                    onChange={() => {
                      this.handleChange1("2");
                    }}
                  />
                </span>

                <div className="display-flex">
                  <div className="width60 margin-right-16">
                    <DynamicForm
                      fields={textinputconverter({
                        value: section && section[0].sectionname,

                        placeholder: "Results",
                        label: "Section A Name",
                      })}
                      onChange={(value) => {
                        this.handleSectionChange(value, "sectionname", 0);
                      }}
                    />
                  </div>
                  <div className="width40">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: section && section[0].weightagetypeid,
                        placeholder: "Select weightage",
                        label: "Section A weightage",
                        options: WeightageType,
                      })}
                      onChange={(value) => {
                        this.handleSectionChange(value, "weightagetypeid", 0);
                      }}
                    />
                  </div>
                </div>
                {this.state.selectedSection == 2 && (
                  <div className="display-flex">
                    <div className="width60 margin-right-16">
                      <DynamicForm
                        fields={textinputconverter({
                          value: section && section[1].sectionname,
                          placeholder: "Behaviour",
                          label: "Section B Name",
                        })}
                        onChange={(value) => {
                          this.handleSectionChange(value, "sectionname", 1);
                        }}
                      />
                    </div>
                    <div className="width40">
                      <DynamicForm
                        fields={selectinputconverter({
                          value: section && section[1].weightagetypeid,
                          placeholder: "Select weightage",
                          label: "Section B weightage",
                          options: WeightageType,
                        })}
                        onChange={(value) => {
                          this.handleSectionChange(value, "weightagetypeid", 1);
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}
export default withSnackbar(reviewperiod);
